module.exports = __webpack_public_path__ + "media/customizations/vanmetre/back-dfdd3ab5e4b9800685212b0b6dd28e91.jpg";